module.exports = __webpack_public_path__ + "img/logo_westudy_small_white.c80d1ef6.png";